export const FLIGHT_ITEM_WRAPPER_SELECTOR =
  '[data-flight-item-with-bundles="true"]';

export const shouldCloseBundlePanel = (eventTarget, flightWrapper) => {
  const clickedFlightItem =
    eventTarget instanceof Element &&
    eventTarget.closest(FLIGHT_ITEM_WRAPPER_SELECTOR);

  return (
    !clickedFlightItem &&
    Boolean(flightWrapper) &&
    !flightWrapper.contains(eventTarget)
  );
};

export const useNewFareImages = (data) => {
  const icons = data?.application?.allegiantBundleIcons || [];
  const banners = data?.application?.bundleCoverImages || [];
  const allImages = [...icons, ...banners];
  return {
    newFareSeatIcon: allImages.find(img => img.id === "newFareBundleSeatIcon")?.path,
    enhancedTripFlexIcon: allImages.find(img => img.id === "enhancedTripflexIcon")?.path,
    newFareBundleBanner: allImages.find(img => img.id === "newFareBundleCover")?.path,
  };
};